export const COMMON_HEADERS_KEYS = {
  X_VOLT_API_VERSION: 'X-Volt-Api-Version',
  X_VOLT_CHANNEL: 'X-Volt-Initiation-Channel',
  CONTENT_TYPE: 'Content-Type',
  AUTHORIZATION: 'X-Volt-App-Authorization',
  X_VOLT_APP: 'X-Volt-App',
} as const;
